import { render, staticRenderFns } from "./TextMessage.vue?vue&type=template&id=8de686b0&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=ts"
export * from "./TextMessage.vue?vue&type=script&lang=ts"
import style0 from "./TextMessage.vue?vue&type=style&index=0&id=8de686b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de686b0",
  null
  
)

export default component.exports